import styled from 'styled-components';

import { NextPageWithLayout } from '../../layouts';
import { FAQSection } from '../PricingPageContent/PricingPageContent';

const Container = styled.div`
  width: 100%;
`;

const QuotesPageContent: NextPageWithLayout = () => {
  return (
    <Container style={{ marginTop: 40 }}>
      <FAQSection />
    </Container>
  );
};

export default QuotesPageContent;
